(() => {
  const grid = document.querySelector('.im-home .category-grid');
  if (!grid) return;

  const closeCards = exception => {
    grid.querySelectorAll('.is-touch-open').forEach(card => {
      if (card === exception) return;
      card.classList.remove('is-touch-open');
      card.blur();
    });
  };

  grid.addEventListener('click', event => {
    const card = event.target.closest('.im-category');
    if (!card || event.detail === 0 || !window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    if (card.classList.contains('is-touch-open')) return;
    event.preventDefault();
    closeCards(card);
    card.classList.add('is-touch-open');
  });
  document.addEventListener('click', event => {
    if (!grid.contains(event.target)) closeCards();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeCards();
  });
})();
